module.exports = __webpack_public_path__ + "static/media/About_Best_Team.41fb6517.svg";